<!-- PROPS
minPageWidthInPixels- defines the minimum size of the page
-->

<template>
  <div
    class="flexed-column-wrapper-fixed-nav"
    style="width: 100%; height:calc(100% - 50px)"
    :style="{minWidth: `${minPageWidthInPixels}px`}"
  >
    <div
      class="fixed-navbar"
      style="width: 100%;"
      :style="{height: `${heightOfNavInPixels}px`}"
    >
      <slot name="nav-slot" />
    </div>
    <div class="rest-of-height" style="width: 100%;">
      <slot name="body-slot" />
    </div>
    <slot name="dialogs" />
  </slot>
  </div>
</template>

<script>
  import './fixedNavBar.styl';

  export default {
    data() {
      return {
      };
    },
    computed: {
    },
    props: {
      minPageWidthInPixels: {
        type: Number,
        default: 0,
      },
      heightOfNavInPixels: {
        type: Number,
        default: 48,
      },
    },
  };
</script>

<style lang="stylus" scoped>
  .rest-of-height
    &&::-webkit-scrollbar {
      display: unset !important;
      position: absolute;
      top: 20px;
      right: 20px;
      margin: 0px;
      width: unset !important;
    }
</style>



// WEBPACK FOOTER //
// fixedNavBar.vue?34ee5a6d